import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Notification {
  id: number;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notifications$ = new BehaviorSubject<Notification[]>([]);
  private idCounter = 0;

  constructor() {}

  getNotifications() {
    return this.notifications$.asObservable();
  }

  showNotification(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration: number = 5000) {
    const notification: Notification = {
      id: ++this.idCounter,
      message,
      type,
      duration
    };

    const currentNotifications = this.notifications$.value;
    this.notifications$.next([...currentNotifications, notification]);

    // Auto-remove después del tiempo especificado
    if (duration > 0) {
      setTimeout(() => {
        this.removeNotification(notification.id);
      }, duration);
    }
  }

  removeNotification(id: number) {
    const currentNotifications = this.notifications$.value;
    const updatedNotifications = currentNotifications.filter(n => n.id !== id);
    this.notifications$.next(updatedNotifications);
  }

  // Métodos de conveniencia
  showSuccess(message: string, duration?: number) {
    this.showNotification(message, 'success', duration);
  }

  showError(message: string, duration?: number) {
    this.showNotification(message, 'error', duration || 7000); // Errores duran más tiempo
  }

  showWarning(message: string, duration?: number) {
    this.showNotification(message, 'warning', duration);
  }

  showInfo(message: string, duration?: number) {
    this.showNotification(message, 'info', duration);
  }
}